<template lang="pug">
  .whb-management-wrapper

    h2 gestão de banco de horas

    .items-slider
      RadioSlider(
        :items="categories.items",
        :current="categories.items.findIndex(i => i.id === categorieSelected.id)",
        @selected="openItemsSelector"
      )

    PMultiSelect.items-selector(
      ref="itemSelector"
      labelItem="name"
      :title="categorieSelected.name"
      :forcedPlaceholder="forcedPlaceholder"
      :useState="categorieSelected.useState"
      :useCommon="categorieSelected.common"
      :disabled="!categories.selected"
      @dblclick="fetchData"
    )

    .buscar
      PButton(color="success" size="md" :block="true", @click="fetchData" :disabled="!validToFetch") Buscar

    .show-resignated
      PCheckbox(v-model="showResignated" label="mostrar demitidos")

    .whb-options
      .whb-selector(v-if="showWhbSelector")
        RadioSlider(
          :items="whbType.items"
          :current="currentWhbType"
          @selected="changeWhbType"
        )
      .old-whb-date-selector(v-if="whbType.selected.id === 'old'")
        DateSlider(@load="fetchOldWhbData")

    //- visão dos empregados com o banco da bv
    template(v-if="whbType.selected.id === 'new'")
      .acumulos(v-if="accumulated.currentPeriod")
        span acúmulo no período atual:
          b {{ accumulated.currentPeriod }}

        span acúmulo no próx. vencimento:
          b {{ accumulated.nextDueDate }}

        span acúmulo total:
          b {{ accumulated.total }}

      SmartTable.table(
        name="whb-table-list"
        v-bind="table"
        v-model="tableData"
        @rowClick="rowClick"
        ref="table"
      )
        template(v-slot:default="slotProps")
          TableRow(v-bind="slotProps")
            template(v-slot:employee.name="{ columnValue, rowItem, index }")
              span.no-wrap(:title="columnValue") {{ columnValue }}

            template(v-slot:currentCicle="{ columnValue, rowItem, index }") {{ columnValue }}
            template(v-slot:currentCicle+1="{ columnValue, rowItem, index }") {{ columnValue }}
            template(v-slot:currentCicle+2="{ columnValue, rowItem, index }") {{ columnValue }}

            template(v-slot:windowExpirationCycle="{ columnValue, rowItem, index }") {{ columnValue }}

            template(v-slot:accumulatedTotal="{ columnValue, rowItem, index }")
              span.accumulated {{ columnValue }}

            template(v-slot:actions="{ columnValue, rowItem, index }")
              PButton(
                v-if="true"
                color="success"
                size="md"
                title="abrir detalhes"
                @click.prevent.stop="abrirDetailsBox(rowItem, index)"
              )
                span Gerenciar

        template(v-slot:detailsBox="{item}")
          WindowDetails(:item="item" @updateMonth="updateMonth")

      Transition(name="fade")
        Accordion.whbmonth(:startOpen="false" v-if="selectedEmployee")
          template(slot="heading")
            span.fs-19(style="text-align: center;") transações do mês

          template
            WhbMonth(:employee="selectedEmployee" ref="whbMmonth")

      Transition(name="fade")
        Accordion.whbchart(:startOpen="false" v-if="selectedEmployee")
          template(slot="heading")
            span.fs-19(style="text-align: center;") acompanhamento do banco de horas

          template
            WhbChart.chart(:employee="selectedEmployee")

    //- visão dos empregados com o banco antigo
    template(v-if="whbType.selected.id === 'old'")

      SmartTable.table(
        name="whb-table-list-old"
        v-bind="tableOld"
        v-model="tableDataOld"
        @rowClick="rowClickOld"
        ref="table"
      )
        template(v-slot:default="slotProps")
          TableRow(v-bind="slotProps")

            template(v-slot:employee.name="{ columnValue, rowItem, index }")
              span.no-wrap(:title="columnValue") {{ columnValue }}

            template(v-slot:actions="{ columnValue, rowItem, index }")
              PButton(
                v-if="true"
                color="success"
                size="md"
                title="abrir detalhes"
                @click.prevent.stop="abrirDetailsBox(rowItem, index)"
              )
                span Gerenciar

        template(v-slot:detailsBox="{item}")
          WindowDetails(:item="item" @updateMonth="updateMonth")

      .whb-closer-expiration(v-if="selectedEmployeeOld")
        .loading(v-if="whbCloserExpirationLoading")
          SkeletonBox(margin="5px 0 0 0" key="whbCloserExpirationOldLoading" width="100%" height="20px")

        .line(v-else-if="whbCloserExpiration")
          span.fs-19.bold
            | última data para acréscimo de evento no banco de horas:&nbsp;
          span.fs-19 {{ whbCloserExpiration }}
          .info.icon-ptt-icons-info.fs-19

          uiv-popover(
            :target="`.icon-ptt-icons-info`"
            trigger="hover"
            placement="top"
          )
            div(slot="popover")
              .popover-content
                div Até a jornada da data apresentada haverá saldo no banco de horas. Após essa data, o banco ficará vencido (aparecendo na cor vermelha) até que a baixa seja realizada.
                  a(target="blank" href="https://suporte.pontotel.com.br/article/180-como-criar-baixa-no-banco-de-horas")

      Transition(name="fade")
        Accordion.whbmonth(:startOpen="false" v-if="selectedEmployeeOld")
          template(slot="heading")
            span.fs-19(style="text-align: center;") transações do mês

          template
            WhbMonth(:employee="selectedEmployeeOld" ref="whbMmonth")

      Transition(name="fade")
        Accordion.whbchart(:startOpen="false" v-if="selectedEmployeeOld")
          template(slot="heading")
            span.fs-19(style="text-align: center;") acumulado do banco de horas

          template
            SumsWHB(
              :sumWhb="sumWhb"
              :loadingSumWhb="loadingSumWhb"
            )

</template>

<script>
import RadioSlider from 'src/common/Tabs/RadioSlider'
import { mapState } from 'vuex'
import WhbMonth from './WhbMonth'
import WhbChart from './WhbChart'
import WindowDetails from './WindowDetails'
import DateSlider from './DateSlider'
import moment from 'moment'
import SumsWHB from 'src/components/Sheets/Timesheet/Sums/Whb/SumsWHB'
import { setAmplitudeEvent } from 'src/amplitudeUtils'

function possuiPermissaoParaGerenciar () {
  return this.$hasPermission({module: 'workhourbankobjects', action: 'post', hide: true})
}

const configHeaderBotaoGerenciar = {column: 'ações', field: 'actions', width: '100px'}

export default {
  name: 'WHBManagement',
  mounted () {
    setAmplitudeEvent('lista gestao banco de horas', {})
  },
  async created () {
    this.categories.selected = this.categories.items[0]
    this.whbType.selected = this.whbType.items[0]

    this.$store.commit('whb/startDate', moment())
    this.$store.commit('whb/endDate', moment())

    try {
      const result = await this.$API.whbCount.get()
      this.employeePerWhb = result.body.success

      const oldWhbEmployees = this.employeePerWhb['old']
      const newWhbEmployees = this.employeePerWhb['new']

      /*
      Essa tela deve poder mostrar as informações do banco de horas comum (old)
      e também o banco de horas da BV (new).

      Então caso exista empregados com os dois whb na mesma comp_man, mostramos
      um seletor de modo
      */
      if (oldWhbEmployees > 0 && newWhbEmployees > 0) {
        this.showWhbSelector = true
      } else if (oldWhbEmployees > 0 && newWhbEmployees === 0) {
        this.whbType.selected = this.whbType.items[1]
      }
    } catch (e) {
      console.warn(e)
    }
  },
  data () {
    return {
      selectedEmployee: null,
      selectedEmployeeOld: null,
      showResignated: false,
      showWhbSelector: false,
      employeePerWhb: null,
      sumWhb: {
        overall: null,
        monthly: null
      },
      loadingSumWhb: false,
      whbType: {
        selected: null,
        items: [
          {id: 'new', name: 'b.h por janela'},
          {id: 'old', name: 'b.h por evento'}
        ]
      },
      categories: {
        selected: null,
        items: [
          { name: 'locais', id: 'company', common: 'companies/onlyActive', useState: 'whb/companies' },
          { name: this.$wp('employee'), id: 'employee', common: 'employees/onlyWithWhbAndNotFired', useState: 'whb/employees' },
          { name: 'grupos', id: 'userGroup', common: 'userGroups', useState: 'whb/userGroups' }
        ]
      },
      tableCustomHeaders: {
        'current': 'venc. período atual',
        'currentCicle+1': 'venc. próximo período',
        'currentCicle+2': 'venc. período seguinte',
        'windowExpirationCycle': 'venc. próximos meses'
      },
      tableData: {loaded: [], loading: false, totalItems: null},
      tableDataOld: {loaded: [], loading: false, totalItems: null},
      accumulated: {total: null, nextDueDate: null, currentPeriod: null},
      whbCloserExpiration: undefined,
      whbCloserExpirationLoading: false
    }
  },
  computed: {
    ...mapState('whb', ['companies', 'employees', 'userGroups', 'startDate']),
    table () {
      const headerItems = [
        // {column: 'código', field: 'employee.code', width: '120px'},
        {column: 'empregado', field: 'employee.name', width: '1fr', userCustom: {hiddable: false}},
        {column: this.tableCustomHeaders.current, field: 'currentCicle', width: '180px'},
        {column: this.tableCustomHeaders['currentCicle+1'], field: 'currentCicle+1', width: '190px'},
        {column: this.tableCustomHeaders['currentCicle+2'], field: 'currentCicle+2', width: '195px'},
        {column: this.tableCustomHeaders.windowExpirationCycle, field: 'windowExpirationCycle', width: '190px'},
        {column: 'acumulado', field: 'accumulatedTotal', width: '120px'}
      ]

      if (possuiPermissaoParaGerenciar.call(this)) headerItems.push(configHeaderBotaoGerenciar)

      return {
        headerItems,
        config: {
          detailsBox: {
            openOnClickRow: this.$hasPermission({module: 'workhourbankobjects', action: 'post', hide: true}),
            onlyOpenWithDoubleClick: true,
            minHeight: 500
          },
          startFocusedSearch: 'employee.name',
          defaultSortField: 'employee.name',
          defaultColumnSearch: 'employee.name'
        }
      }
    },
    tableOld () {
      const headerItems = [
        {column: 'código', field: 'employee.code', width: '120px'},
        {column: 'empregado', field: 'employee.name', width: '1fr'},
        // {column: 'saldo até esse momento', field: 'hours_formatted_overall.all_times', width: '.7fr'},
        {column: 'saldo do mês', field: 'hours_formatted_monthly.all_times', width: '.7fr'}
      ]

      if (possuiPermissaoParaGerenciar.call(this)) headerItems.push(configHeaderBotaoGerenciar)

      return {
        headerItems,
        config: {
          detailsBox: {
            openOnClickRow: this.$hasPermission({module: 'workhourbankobjects', action: 'post', hide: true}),
            onlyOpenWithDoubleClick: true,
            minHeight: 500,
            numberColumnsKeep: 0
          },
          startFocusedSearch: 'employee.name',
          defaultSortField: 'employee.name',
          defaultColumnSearch: 'employee.name'
        }
      }
    },
    validToFetch () {
      const respective = {company: 'companies', employee: 'employees', userGroup: 'userGroups'}

      if (this[respective[this.categories.selected.id]].selected.length > 0) {
        return true
      }
      return false
    },
    categorieSelected () {
      if (this.categories.selected?.id === 'employee' && this.showResignated) {
        return {...this.categories.selected, common: 'employees/onlyWithWhb'}
      }

      if (this.categories.selected) return this.categories.selected
      return {name: 'Selecionar', id: 0, common: '', useState: 'timesheet/header/companies'}
    },
    forcedPlaceholder () {
      const companies = this.companies.selected
      const employees = this.employees.selected
      const userGroups = this.userGroups.selected

      if (companies.length || employees.length || userGroups.length) {
        return null
      }

      if (this.categories.selected.id === 'company') {
        return 'selecionar locais'
      } else if (this.categories.selected.id === 'employee') {
        return `selecionar ${this.$wp('employee')}`
      } else {
        return 'selecionar grupos'
      }
    },
    currentWhbType () {
      return this.whbType.items.findIndex(i => i.id === this.whbType.selected.id)
    }
  },
  methods: {
    abrirDetailsBox (rowItem, index) {
      this.$refs.table.openDetailsBox(rowItem, index)
    },
    openItemsSelector (item) {
      this.categories.selected = item
      this.$refs.itemSelector.open()
    },
    getData () {
      const companies = this.companies.selected
      const employees = this.employees.selected
      const userGroups = this.userGroups.selected

      const data = {'showResignated': this.showResignated}

      if (!companies.length && !employees.length & !userGroups.length) {
        return null
      }

      if (this.categories.selected.id === 'company') {
        data['companies'] = companies.map(c => c.id)
      } else if (this.categories.selected.id === 'employee') {
        data['employees'] = employees.map(e => e.id)
      } else if (this.categories.selected.id === 'userGroup') {
        data['userGroups'] = userGroups.map(ug => ug.id)
      } else return null

      return data
    },
    async fetchData () {
      this.$refs.table.closeDetailsBox()

      const data = this.getData()

      if (data !== null && this.employeePerWhb['new'] > 0) {
        try {
          const result = await this.$API.whbWindowManagement.save(data)

          this.tableData.loaded = result.data.success.duePerEmployees.map(empWindow => {
            return {
              ...empWindow,
              'currentCicle': empWindow['currentCicle'],
              'currentCicle+1': empWindow['currentCicle+1'],
              'currentCicle+2': empWindow['currentCicle+2'],
              'windowExpirationCycle': empWindow['windowExpirationCycle']
            }
          })
          if (result.data.success.tableCustomHeaders) {
            this.tableCustomHeaders['current'] = result.data.success.tableCustomHeaders['current']
            this.tableCustomHeaders['currentCicle+1'] = result.data.success.tableCustomHeaders['currentCicle+1']
            this.tableCustomHeaders['currentCicle+2'] = result.data.success.tableCustomHeaders['currentCicle+2']
            this.tableCustomHeaders['windowExpirationCycle'] = result.data.success.tableCustomHeaders['windowExpirationCycle']
          }
          this.accumulated = result.data.success.accumulated
        } catch (e) {
          console.error(e)
        }
      }

      if (this.employeePerWhb['old'] > 0) {
        await this.fetchOldWhbData()
      }
    },
    async fetchOldWhbData () {
      const data = this.getData()

      if (data === null) {
        return
      }

      this.tableDataOld.loading = true
      this.selectedEmployeeOld = null
      const result = await this.$API.whboManagerNew.save({
        ...data,
        startDate: moment(this.startDate).startOf('month').format('YYYY-MM-DD')
      })
      this.tableDataOld.loaded = result.body.success

      this.tableDataOld.loading = false
    },
    async rowClick (rowItem, columnValue, index) {
      this.selectedEmployee = rowItem.employee
      if (this.$refs.whbMmonth) {
        this.$refs.whbMmonth.fetchMonthData()
      }
    },
    async rowClickOld (rowItem, columnValue, index) {
      this.loadingSumWhb = true
      this.selectedEmployeeOld = rowItem.employee

      const result = await this.$API.whboManager.get({
        kind: 'overall',
        employeeId: rowItem.employee.id,
        startDate: moment(this.startDate).startOf('month').format('YYYY-MM-DD')
      })
      const hoursFormattedOverall = result.body.success

      await this.fetchWhbCloserInfo(rowItem.employee.id)

      this.sumWhb = {
        overal: hoursFormattedOverall,
        monthly: rowItem.hours_formatted_monthly
      }

      this.loadingSumWhb = false
    },
    updateMonth () {
      this.$refs.whbMmonth.fetchMonthData()
    },
    changeWhbType (item) {
      this.whbType.selected = item
    },
    async fetchWhbCloserInfo (employeeId) {
      this.whbCloserExpirationLoading = true

      try {
        const result = await this.$API.whbCloser.get({employeeId: employeeId})
        const baixas = (result.data?.success || [])

        if (baixas.length) {
          const lastWhbClose = baixas[baixas.length - 1]
          const whbCloserExpiration = lastWhbClose && lastWhbClose.expiration
            ? moment(lastWhbClose.expiration).format('DD/MM/YYYY')
            : undefined

          this.whbCloserExpiration = whbCloserExpiration
        } else {
          this.whbCloserExpiration = undefined
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.whbCloserExpirationLoading = false
      }
    }
  },
  destroyed () {
    this.$store.commit('whb/resetState')
  },
  components: { RadioSlider, WhbMonth, WhbChart, WindowDetails, DateSlider, SumsWHB }
}
</script>

<style scoped lang="scss">
.whb-management-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr .3fr .3fr;
  grid-row-gap: 20px;
  grid-column-gap: 20px;
  margin-bottom: 40px;

  h2 {
    text-align: center;
    grid-column: 1/5;
  }

  .items-slider {
    grid-column: 1/2;
    grid-row: 2;
    display: grid;
    align-items: center;
  }

  .items-selector {
    grid-column: 2/3;
    grid-row: 2;
  }

  .acumulos {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column: 1/5;

    span {
      &:last-child {
        text-align: right;
      }
      align-self: center;
      font-size: 19px;
      b {
        margin-left: 5px;
        color: var(--color-primary);
      }

    }
  }

  .buscar {
    align-self: flex-end;
    margin-bottom: 13px;
    grid-column: 4;
  }

  .show-resignated {
    grid-row: 2;
    align-self: center;
    grid-column: 3;
  }

  .whb-options {
    grid-row: 3;
    grid-column: 1 / 5;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;

    .old-whb-date-selector {
      grid-column: 3 / 4;
    }
  }

  .table {
    grid-column: 1/5;

    span.accumulated {
      color: var(--color-success-contrast);
      background-color: var(--color-success);
      text-align: center;
      width: 50%;
    }
  }

  .whb-closer-expiration {
    grid-column: 1/5;
    text-align: center;

    .line {
      display: flex;
      justify-content: center;
      align-items: center;

      .info {
        margin-left: 2px;
      }
    }
  }

  .whbmonth, .whbchart { grid-column: 1/5; }

  .whbchart {
    .chart {
      height: 350px;
    }
  }
}
</style>
